// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"10447289","486":"0a2fae69","698":"0a2fae69","971":"0a2fae69"}[chunkId] + ".chunk.css";
};